import { render } from "./CompetitionComponent.vue?vue&type=template&id=1a2d1550&scoped=true"
import script from "./CompetitionComponent.vue?vue&type=script&lang=js"
export * from "./CompetitionComponent.vue?vue&type=script&lang=js"

import "./CompetitionComponent.vue?vue&type=style&index=0&id=1a2d1550&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1a2d1550"]])

export default __exports__